import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth on mount
    const storedToken = sessionStorage.getItem('auth_token');
    const storedUser = sessionStorage.getItem('auth_user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = useCallback((authData) => {
    setToken(authData.access_token);
    setUser(authData.user);
    sessionStorage.setItem('auth_token', authData.access_token);
    sessionStorage.setItem('auth_user', JSON.stringify(authData.user));
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    sessionStorage.removeItem('auth_token');
    sessionStorage.removeItem('auth_user');
  }, []);

  const isEmployee = user && !user.role;
  const isAdmin = user && user.role;
  const isSuperAdmin = user && user.role === 'super_admin';
  const isSrManagement = user && user.role === 'sr_management';
  const hasRawDataAccess = isSuperAdmin || (isSrManagement && user?.raw_data_access === true);
  const isReadOnly = isSrManagement;

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      login,
      logout,
      isEmployee,
      isAdmin,
      isSuperAdmin,
      isSrManagement,
      hasRawDataAccess,
      isReadOnly
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
